var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkFlowHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74362 7.65769V6.29638C3.74362 5.63818 3.21066 5.10522 2.55247 5.10522H1.19115C0.532955 5.10522 0 5.63818 0 6.29638V7.65769C0 8.31589 0.532955 8.84884 1.19115 8.84884H2.55247C3.21066 8.84884 3.74362 8.31589 3.74362 7.65769Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18893 7.65769V6.29638C9.18893 5.63818 8.65598 5.10522 7.99778 5.10522H6.63646C5.97827 5.10522 5.44531 5.63818 5.44531 6.29638V7.65769C5.44531 8.31589 5.97827 8.84884 6.63646 8.84884H7.99778C8.65598 8.84884 9.18893 8.31589 9.18893 7.65769Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6342 7.65769V6.29638C14.6342 5.63818 14.1013 5.10522 13.4431 5.10522H12.0818C11.4236 5.10522 10.8906 5.63818 10.8906 6.29638V7.65769C10.8906 8.31589 11.4236 8.84884 12.0818 8.84884H13.4431C14.1013 8.84884 14.6342 8.31589 14.6342 7.65769Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38232 3.23313V1.87181C2.38232 1.40216 2.76348 1.02099 3.23314 1.02099H5.95577C6.42542 1.02099 6.80659 1.40216 6.80659 1.87181C6.80659 2.55247 6.80659 3.23313 6.80659 3.23313C6.80659 3.51492 7.03529 3.74362 7.31709 3.74362C7.59888 3.74362 7.82758 3.51492 7.82758 3.23313C7.82758 3.23313 7.82758 2.55247 7.82758 1.87181C7.82758 0.83789 6.98969 0 5.95577 0C5.12401 0 4.0649 0 3.23314 0C2.19922 0 1.36133 0.83789 1.36133 1.87181V3.23313C1.36133 3.51492 1.59003 3.74362 1.87182 3.74362C2.15361 3.74362 2.38232 3.51492 2.38232 3.23313Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80664 10.7203V12.0816C6.80664 13.1156 7.64453 13.9535 8.67845 13.9535C9.51021 13.9535 10.5693 13.9535 11.4011 13.9535C12.435 13.9535 13.2729 13.1156 13.2729 12.0816C13.2729 11.401 13.2729 10.7203 13.2729 10.7203C13.2729 10.4385 13.0442 10.2098 12.7624 10.2098C12.4806 10.2098 12.2519 10.4385 12.2519 10.7203C12.2519 10.7203 12.2519 11.401 12.2519 12.0816C12.2519 12.5513 11.8707 12.9325 11.4011 12.9325H8.67845C8.2088 12.9325 7.82763 12.5513 7.82763 12.0816V10.7203C7.82763 10.4385 7.59893 10.2098 7.31713 10.2098C7.03534 10.2098 6.80664 10.4385 6.80664 10.7203Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59513 2.57292L6.95645 3.93423C7.15588 4.13366 7.47851 4.13366 7.67794 3.93423L9.03926 2.57292C9.23869 2.37416 9.23869 2.05017 9.03926 1.85142C8.84051 1.65199 8.51652 1.65199 8.31776 1.85142L7.3172 2.8513L6.31663 1.85142C6.11788 1.65199 5.79388 1.65199 5.59513 1.85142C5.3957 2.05017 5.3957 2.37416 5.59513 2.57292Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7617 12.1025L12.7623 11.1026L13.7628 12.1025C13.9616 12.3019 14.2856 12.3019 14.4843 12.1025C14.6838 11.9038 14.6838 11.5798 14.4843 11.381L13.123 10.0197C12.9236 9.82026 12.6009 9.82026 12.4015 10.0197L11.0402 11.381C10.8408 11.5798 10.8408 11.9038 11.0402 12.1025C11.239 12.3019 11.5629 12.3019 11.7617 12.1025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkFlowHistory);
export default __webpack_public_path__ + "static/media/WorkFlowHistory.150aaaea569fc54908427f12cc85462a.svg";
export { ForwardRef as ReactComponent };